/**
 * Create a browser cookie.
 * @param name Name of the cookie
 * @param value Value of the cookie
 * @param expirationByNoOfDays Number of days the cookie stays valid
 * @param secure Cookie can only be transmitted through HTTPS
 * @param domain If the cookie needs to be accessible to websites in another subdomain, define the domain
 */
const createCookie = (
  name: string,
  value: string,
  expirationByNoOfDays?: number,
  secure?: boolean,
  domain?: string
) => {
  let expiry = "";

  if (expirationByNoOfDays) {
    const date = new Date();

    date.setTime(date.getTime() + expirationByNoOfDays * 24 * 60 * 60 * 1000);
    expiry = date.toUTCString();
  }

  document.cookie = `${name}=${value}; Expires=${expiry}; Path=/;${secure ? " Secure;" : ""} SameSite=Strict${
    domain ? `; Domain=.${domain}` : ""
  }`;
};

// Taken from https://stackoverflow.com/a/25346429
// But modified for simplicity as it's unnecessary to cover all use cases
const getCookie = (name: string) => {
  const match = document.cookie.match(RegExp(`(?:^|;\\s*)${name}=([^;]*)`));

  return match ? match[1] : "";
};

const deleteCookie = (name: string) => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict`;
};

export { createCookie, getCookie, deleteCookie };
